module.exports = __webpack_public_path__ + "static/media/404.a57b6f31.png";